import React from 'react';
import PropTypes from 'prop-types';

const DashboardCardHeader = ({ 
	title, 
	value, 
	icon, 
	isLoading = false, 
	className = "",
	valueClassName = "",
	titleClassName = "",
	iconClassName = ""
}) => {
	return (
		<div className={`flex justify-between items-start mb-6 ${className}`}>
			<div>
				<h3 className={`text-sm font-montserrat-medium text-gray-700 uppercase tracking-wide ${titleClassName}`}>
					{title}
				</h3>
				<p className={`text-2xl sm:text-3xl font-glacial text-gray-900 mt-2 ${valueClassName}`}>
					{isLoading ? '...' : value}
				</p>
			</div>
			<div className={`rounded-full p-4 bg-gray-100 ${iconClassName}`}>
				{icon}
			</div>
		</div>
	);
};

DashboardCardHeader.propTypes = {
	title: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
		PropTypes.node
	]).isRequired,
	icon: PropTypes.node.isRequired,
	isLoading: PropTypes.bool,
	className: PropTypes.string,
	valueClassName: PropTypes.string,
	titleClassName: PropTypes.string,
	iconClassName: PropTypes.string
};

export default DashboardCardHeader;